export const onFormatPaymentStatus = (status: string) => {
    switch (status) {
        case 'pending':
            return { name: 'PENDING', color: 'border-[#f7a21e]', text: 'text-[#f7a21e]' }
        case 'completed':
            return { name: 'COMPLETED', color: 'border-[#00b67a]', text: 'text-[#00b67a]' }
        case 'canceled':
            return { name: 'CANCELED', color: 'border-[#E50000]', text: 'text-[#E50000]' }
        default:
            return { name: status, color: 'border-[#1389e6]', text: 'text-[#1389e6]' }
    }
}